import React from 'react';

import { Row, Card, Col, ListGroupItem, ListGroup } from 'reactstrap';

import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import ReportService from '../service';
import { TotalRegister } from '../../../../../components/TotalRegister';
import { AudioStreamReportTelephony as AudioStream } from '../../../../../components/AudioController/AudioStream';
import { verifyRoles } from 'components/Authentication/VerifyRoles';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import { DownloadButton } from '../components/DownloadButton';
import ColumnHeader from '../../utils/ColumnHeader';

const itemStyle = { padding: '5px 0 0 20px' };

const analitical = ({
  showReports,
  isMultiDownload,
  selectedRows,
  handleOnSelectAll,
  handleOnSelect,
  quantity,
  extraDataFromAnalyticalReport,
  needPermission = false,
  isDownloadAndListen = true,
  agentCode
}) => {
  const isDownload = () => {
    if (isDownloadAndListen) {
      return needPermission
        ? [
            verifyRoles(['DOWNLOAD_CALLS']) && {
              dataField: 'download',
              text: 'Download',
              sort: true,
              style: individual_column_style,
              headerStyle: individual_header_style,
              // eslint-disable-next-line react/display-name
              formatter: (_, row) => {
                return (
                  <DownloadButton row={row} isCallMade={true}></DownloadButton>
                );
              }
            },
            verifyRoles(['LISTEN_CALLS']) && {
              dataField: 'listen',
              text: 'Escutar',
              sort: true,
              style: individual_column_style,
              headerStyle: individual_header_style,

              // eslint-disable-next-line react/display-name
              formatter: (_, row) => {
                return (
                  <AudioStream
                    ReportService={ReportService}
                    uniqueid={row.uniqueid}
                    disabled={row.disposition === 'ANSWERED' ? false : true}
                  />
                );
              }
            }
          ]
        : [
            verifyRoles(['MONITORING_CALLCENTER_DOWNLOAD']) && {
              dataField: 'download',
              text: 'Download',
              sort: true,
              style: individual_column_style,
              headerStyle: individual_header_style,
              // eslint-disable-next-line react/display-name
              formatter: (_, row) => {
                return (
                  <DownloadButton row={row} isCallMade={true}></DownloadButton>
                );
              }
            },
            verifyRoles(['MONITORING_CALLCENTER_LISTEN']) && {
              dataField: 'listen',
              text: 'Escutar',
              sort: true,
              style: individual_column_style,
              headerStyle: individual_header_style,

              // eslint-disable-next-line react/display-name
              formatter: (_, row) => {
                return (
                  <AudioStream
                    ReportService={ReportService}
                    uniqueid={row.uniqueid}
                    disabled={row.disposition === 'ANSWERED' ? false : true}
                  />
                );
              }
            }
          ];
    }
    return [{}];
  };

  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            {quantity >= 0 && <TotalRegister totalRegister={quantity} />}
            <Card>
              <ToolkitProvider
                data={showReports}
                keyField="uuid"
                columns={[
                  {
                    dataField: 'calldateStart',
                    text: <ColumnHeader title="Data início" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return `${date.toLocaleDateString(
                        'pt-br'
                      )} ${date.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'calldateEnd',
                    text: 'Data final',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return `${date.toLocaleDateString(
                        'pt-br'
                      )} ${date.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'clidNum',
                    text: <ColumnHeader title="Origem" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'dst',
                    text: <ColumnHeader title="Destino" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'nameAgent',
                    text: <ColumnHeader title="Nome do agente" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },

                  ...(agentCode
                    ? [
                        {
                          dataField: 'codeAgent',
                          text: (
                            <span>
                              Codigo do Agente{' '}
                              <i
                                className="fa fa-sort"
                                style={{
                                  marginLeft: '10px',
                                  fontSize: '1.2em'
                                }}
                              ></i>
                            </span>
                          ),
                          sort: true,
                          style: individual_column_style,
                          headerStyle: individual_header_style
                        }
                      ]
                    : []),

                  {
                    dataField: 'ddr',
                    text: <ColumnHeader title="DDR" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'queue',
                    text: <ColumnHeader title="Fila" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'centroDeCusto',
                    text: <ColumnHeader title="Setor" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'carrier',
                    text: <ColumnHeader title="Operadora" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'dispositionFormated',
                    text: <ColumnHeader title="Status da chamada" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'transferIn',
                    text: <ColumnHeader title="Recebeu transferência de" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'transferOut',
                    text: <ColumnHeader title="Transferiu para" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timeCallFormated',
                    text: <ColumnHeader title="Tempo em ligação" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'timeWaitingCallFormated',
                    text: <ColumnHeader title="Tempo em espera" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'amdStatus',
                    text: <ColumnHeader title="AMD status" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'hangupCauseDescription',
                    text: <ColumnHeader title="Causa Desligamentos" />,
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },

                  //trabalhar nesses dois pois ambos são audios
                  ...isDownload()
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    {isMultiDownload ? (
                      <BootstrapTable
                        selectRow={{
                          mode: 'checkbox',
                          selected: selectedRows.map((r) => r.uuid),
                          onSelect: handleOnSelect,
                          onSelectAll: handleOnSelectAll,
                          nonSelectable: showReports.map((row) => {
                            if (row.disposition !== 'ANSWERED') {
                              return row.uuid;
                            }
                          })
                        }}
                        bootstrap4={true}
                        bordered={false}
                        classes="align-items-center"
                        {...props.baseProps}
                      />
                    ) : (
                      <BootstrapTable
                        bootstrap4={true}
                        bordered={false}
                        classes="align-items-center"
                        {...props.baseProps}
                      />
                    )}
                  </div>
                )}
              </ToolkitProvider>
              {quantity > 0 && (
                <Row className="mb-3 mt-3">
                  <Col md="3">
                    <ListGroup flush>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Chamadas atendidas:
                        </span>{' '}
                        {extraDataFromAnalyticalReport.quantityCallAnswer}
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Chamadas não atendidas:
                        </span>{' '}
                        {extraDataFromAnalyticalReport.quantityCallNoAnswer}
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Tempo médio de Serviço:
                        </span>{' '}
                        {
                          extraDataFromAnalyticalReport.averageServiceTimeFormated
                        }
                      </ListGroupItem>
                      <ListGroupItem disabled style={itemStyle}>
                        <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                          Tempo médio de Espera:
                        </span>{' '}
                        {
                          extraDataFromAnalyticalReport.waitingServiceTimeFormated
                        }
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row>
              )}
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default analitical;
